import { createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../../../Common/Interceptors/AxiosConfig";
import { showNotification } from "../../../../../Common/Toast/Toast";

const initialState = {
  errors: null,
  isLoading: false,
  campaigns: [],
  wallet: null,
  submissions: [],
  templates: [],
  selectedTemplate: null,
  cashbackCalculation: null,
};

const MarketingSlice = createSlice({
  name: "marketing",
  initialState,
  reducers: {
    setErrors: (state, action) => {
      // Ensure error is always a string or null to prevent React rendering crashes (Error #31)
      state.errors = typeof action.payload === 'string' 
        ? action.payload 
        : (action.payload?.message || "An unexpected error occurred");
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setCampaigns: (state, action) => {
      state.campaigns = action.payload;
    },
    setWallet: (state, action) => {
      state.wallet = action.payload;
    },
    setSubmissions: (state, action) => {
      state.submissions = action.payload;
    },
    setTemplates: (state, action) => {
      state.templates = action.payload;
    },
    setSelectedTemplate: (state, action) => {
      state.selectedTemplate = action.payload;
    },
    setCashbackCalculation: (state, action) => {
      state.cashbackCalculation = action.payload;
    },
  },
});

export const fetchCampaigns = () => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get("marketing/campaigns");
    if (response.data?.success) {
      dispatch(setCampaigns(response.data.data));
    }
  } catch (error) {
    dispatch(setErrors(error.message));
  } finally {
    dispatch(setLoading(false));
  }
};

export const fetchWallet = () => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get("marketing/wallet");
    if (response.data?.success) {
      dispatch(setWallet(response.data.data));
    }
  } catch (error) {
    dispatch(setErrors(error.message));
  } finally {
    dispatch(setLoading(false));
  }
};

export const getTemplates = (category, providerId) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get(`marketing/templates?category=${category}&providerId=${providerId}`);
    if (response.data?.success) {
      dispatch(setTemplates(response.data.data));
    }
  } catch (error) {
    
  } finally {
    dispatch(setLoading(false));
  }
};

export const calculateCashbackPreview = (servicePrice, reach) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`marketing/reels/calculate-preview?servicePrice=${servicePrice}&reach=${reach}`);
    if (response.data?.success) {
      dispatch(setCashbackCalculation(response.data.data));
    }
  } catch (error) {
    
  }
};

export const incrementTemplateUsage = (templateId) => async (dispatch) => {
  try {
    await axiosInstance.post(`marketing/templates/${templateId}/usage`);
  } catch (error) {
    
  }
};

export const submitReel = (submissionData) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.post("marketing/reels/submissions", submissionData);
    if (response.data?.success) {
      showNotification({
        message: "Reel submitted successfully!",
        type: "success",
      });
      return { success: true };
    }
  } catch (error) {
    showNotification({
      message: error.response?.data?.message || "Submission failed",
      type: "error",
    });
    return { success: false };
  } finally {
    dispatch(setLoading(false));
  }
};

export const { 
  setErrors, 
  setLoading, 
  setCampaigns, 
  setWallet, 
  setSubmissions,
  setTemplates,
  setSelectedTemplate,
  setCashbackCalculation
} = MarketingSlice.actions;
export default MarketingSlice.reducer;
